<template>
  <div class="tag-filter">
    <ul class="tag-filter__list">
      <li class="tag-filter__item" v-for="tag in tags" :key="tag.Id">
        <button :id="tag.Id" @click="emitCategory(tag.Name)" class="tag__button" :class="{ 'tag__button--active': selectedTags.includes(tag.Name) }">
          {{ tag.Name }}
          <transition name="fade">
            <span v-if="selectedTags.includes(tag.Name)" class="tag__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="" height="" viewBox="0 0 64 64">
                <path data-name="Rectangle 105" fill="none" d="M0 0h64v64H0z" /><path data-name="Icon-Cross" d="M59.24 8.331a2.37 2.37 0 00.76-1.78 2.49 2.49 0 00-.76-1.83 2.45 2.45 0 00-1.79-.72 2.57 2.57 0 00-1.82.72L32 28.391 8.33 4.721a2.44 2.44 0 00-1.78-.72 2.58 2.58 0 00-1.83.72A2.58 2.58 0 004 6.551a2.44 2.44 0 00.72 1.78l23.67 23.67-23.67 23.63a2.57 2.57 0 00-.72 1.82 2.45 2.45 0 00.72 1.79 2.49 2.49 0 001.83.76 2.37 2.37 0 001.78-.76L32 35.611l23.63 23.63a2.49 2.49 0 001.82.76 2.6 2.6 0 002.55-2.55 2.49 2.49 0 00-.76-1.82l-23.63-23.63z" />
              </svg>
            </span>
          </transition>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
    data() {
        return {
            isToggleActive: true
        }
    },
    props: {
        tags: {
            type: Array,
            default: () => []
        },
        defaultSelectedTags: {
            type: Array,
            default: () => []
        },
        distIconPath: {
            type: String,
            required: false,
            default: '/dist/images/icons.svg'
        }
    },
    methods: {
        emitCategory(selectedTag) {
            if(this.selectedTags.includes(selectedTag)) {
                const index = this.selectedTags.indexOf(selectedTag)
                if (index !== -1) {
                    this.selectedTags.splice(index, 1)
                }
            }
            else {
                this.selectedTags.push(selectedTag)
            }
            this.$emit('selectedCategory', this.selectedTags)
        }
    },
    computed: {
        selectedTags() {
            if(this.defaultSelectedTags) {
                return [...this.defaultSelectedTags]
            }
            return []
        }
    }
}
</script>